/**
 * Paywall Return-to-Publication utility
 *
 * Stores/retrieves the publication URL so that after payment checkout,
 * the user is redirected back to the publication they were reading.
 */

const STORAGE_KEY = 'paywall_return_publication';

/**
 * Store the current publication path before navigating to checkout.
 * Called by the paywall CTA component before redirecting to plans/checkout.
 */
export function storePaywallReturnUrl(path: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // sessionStorage may be unavailable (private browsing, etc.)
  }
}

/**
 * Retrieve and remove the stored publication return URL.
 * Returns null if no URL was stored.
 * One-time read: clears the value after retrieval.
 */
/**
 * Read the stored publication return URL without removing it.
 * Use this when you need to reference the URL but preserve it
 * for a later consumer (e.g., CheckoutConfirmation fallback).
 */
export function peekPaywallReturnUrl(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Retrieve and remove the stored publication return URL.
 * Returns null if no URL was stored.
 * One-time read: clears the value after retrieval.
 */
export function getPaywallReturnUrl(): string | null {
  try {
    const url = sessionStorage.getItem(STORAGE_KEY);
    if (url) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    return url;
  } catch {
    return null;
  }
}
